import { Component, OnInit, ChangeDetectionStrategy, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { CalendarView, CalendarEvent, DAYS_OF_WEEK, CalendarDateFormatter, CalendarEventAction } from 'angular-calendar';
import { colors } from './utils/colors';
import { CustomDateFormatter } from './utils/custom-date-formatter.provider';
import { EventsService } from 'src/app/core/services/events/events.service';


@Component({
  selector: 'app-calendar-view-week',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './calendar-view-week.component.html',
  providers: [
    {
      provide: CalendarDateFormatter,
      useClass: CustomDateFormatter,
    },
  ],
  styleUrls: []
})
export class CalendarViewWeekComponent implements OnInit {

  @Input() inputEvents: CalendarEvent<{ description: string }>[] = [];
  @Input() isForAdmin = false;

  @Output() deleteEvent: EventEmitter<string | number> = new EventEmitter();
  @Output() openEventDetails: EventEmitter<string | number> = new EventEmitter();

  view: CalendarView = CalendarView.Week;
  viewDate: Date = new Date();
  locale = 'it';
  weekStartsOn: number = DAYS_OF_WEEK.MONDAY;
  weekendDays: number[] = [DAYS_OF_WEEK.SATURDAY, DAYS_OF_WEEK.SUNDAY];
  events: CalendarEvent<{ description: string }>[];

  openDetailsAction: CalendarEventAction = {
    label: '<i class="fa fa-info-circle" aria-hidden="true"></i>',
    onClick: ({ event }: { event: CalendarEvent<{ description: string }> }): void => {
      // console.log('Inviando id dell\'evento: ' + event.id);
      // console.log('STORE STATUS AFTER UNLEASH ACTION');
      // console.log(this.service.events);
      this.openEventDetails.emit(event.id);
    },
    cssClass: 'event-icon'
  };
  deleteEventAction: CalendarEventAction = {
    label: '<i class="fa fa-trash" aria-hidden="true"></i>',
    onClick: ({ event }: { event: CalendarEvent<{ description: string }> }): void => {
      this.deleteEvent.emit(event.id);
    },
    cssClass: 'event-icon'
  };


  constructor(private service: EventsService) {
    this.events = [];
  }


  ngOnInit(): void {
    //console.log('STORE STATUS FROM THE CALENDATR');
    //console.log(this.service.events);
    

    if (this.isForAdmin) {
      this.events = this.addActionsToEvents(this.inputEvents, [this.deleteEventAction, this.openDetailsAction]);
      
      //console.log('EVENTS WITH ACTIONS');
      //console.log(this.events);

    } else {
      this.events = this.addActionsToEvents(this.inputEvents, [this.openDetailsAction]);
      //console.log('EVENTS WITH ACTIONS');
      //console.log(this.events);
    }
  }



  addActionsToEvents(
    events: CalendarEvent<{ description: string }>[],
    eventActions: CalendarEventAction[]
  ): CalendarEvent[] {

    const eventsWithActions: CalendarEvent<{ description: string }>[] = [];
    events.forEach(event => {
      eventsWithActions.push({
        id: event.id,
        start: new Date(event.start),
        end: new Date(event.end),
        title: event.title,
        color: colors.orange,
        actions: eventActions,
        cssClass: 'custom-event',
        meta: {
          description: event.meta.description
        }
      });
    });

    return eventsWithActions;
  }

}
